import { Box, Link, Stack, Text } from "@chakra-ui/react";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { FormattedMessage } from "react-intl";

/**
 * @typedef {object} Props
 * @property {import("@raiden/library/types/Configuration").ConfigurationEnvironment} environment
 */

/**
 * @param {Props} props
 */
export function PersonnalInformation({ environment }) {
  return (
    <Box
      bgImage={`url(${generateFrontPath({
        id: "@front.internal-assets",
        parameters: { filePath: "pattern-with-gradient.png" },
        includeBasePath: true,
      })})`}
      position="relative"
      marginBottom="auto"
      bgSize="auto"
      bgPosition="center">
      <Stack padding="1.5rem" spacing="1.5rem">
        <Text color="white" variant="h3" whiteSpace="pre-line">
          {environment.company_name}
        </Text>

        <Text variant="text-large" color="white">
          <Link href={`tel:${environment.phone_number}`} display="inline-block">
            {environment.phone_number
              .replace("+33", "0")
              .replace(/(..)/g, "$1 ")}
          </Link>
        </Text>

        <Text variant="text-button" color="white">
          <Link href={`mailto:${environment.email}`} target="_blank">
            {environment.email}
          </Link>
        </Text>

        <Stack spacing="1rem">
          <Box>
            {environment.address_1 && (
              <Text color="white">{environment.address_1}</Text>
            )}

            {(environment.zipcode || environment.city) && (
              <Text color="white">{`${
                environment.zipcode ? environment.zipcode : ""
              } ${environment.city ? environment.city : ""}`}</Text>
            )}
          </Box>

          <Text as="div">
            <Link
              color="white"
              textDecoration="underline"
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                `${environment.company_name}, ${environment.zipcode}`,
              )}`}
              target="_blank">
              <FormattedMessage defaultMessage="Voir sur Google Maps" />
            </Link>
          </Text>
        </Stack>
      </Stack>
    </Box>
  );
}
